import { createAsyncAction, createAction } from 'typesafe-actions';
import { User, Account, Service } from './types';
import { AxiosError } from 'axios';

export const SET_TOKEN = 'auth/SET_TOKEN';
export const setToken = createAction(SET_TOKEN)<string|undefined>();

export const SET_USER = 'auth/SET_USER';
export const setUser = createAction(SET_USER)<User>();

export const SET_ACCOUNT = 'auth/SET_ACCOUNT';
export const setAccount = createAction(SET_ACCOUNT)<Account>();

export const SET_PLAN = 'auth/SET_PLAN';
export const setPlan = createAction(SET_PLAN)<any>();

export const SET_SERVICE = 'auth/SET_SERVICE';
export const setService = createAction(SET_SERVICE)<Service>();

export const GET_USER = 'auth/GET_USER';
export const GET_USER_SUCCESS = 'auth/GET_USER_SUCCESS';
export const GET_USER_ERROR = 'auth/GET_USER_ERROR';

export const GET_ACCOUNT = 'auth/GET_ACCOUNT';
export const GET_ACCOUNT_SUCCESS = 'auth/GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_ERROR = 'auth/GET_ACCOUNT_ERROR';

export const LOGIN = 'auth/LOGIN';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';

export const getUser = createAsyncAction(
	GET_USER,
	GET_USER_SUCCESS,
	GET_USER_ERROR,
)<void, User, AxiosError>();

export const getAccount = createAsyncAction(
	GET_ACCOUNT,
	GET_ACCOUNT_SUCCESS,
	GET_ACCOUNT_ERROR,
)<void, Account, AxiosError>();

export const login = createAsyncAction(
	LOGIN,
	LOGIN_SUCCESS,
	LOGIN_ERROR,
)<any, string, AxiosError>();